import { render, staticRenderFns } from "./OptionButtonItem.vue?vue&type=template&id=03fdbd58&scoped=true&"
import script from "./OptionButtonItem.vue?vue&type=script&lang=ts&"
export * from "./OptionButtonItem.vue?vue&type=script&lang=ts&"
import style0 from "./OptionButtonItem.vue?vue&type=style&index=0&id=03fdbd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fdbd58",
  null
  
)

export default component.exports